<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{
                $t("configuracion")
              }}</router-link>
            </li>
            <li class="breadcrumb-item" v-if="SpProv == 0">
              <router-link :to="{
                name: 'subproductos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness },
              }">
                {{ $t("subproductos") }}
              </router-link>
            </li>
            <li class="breadcrumb-item" v-if="SpProv == 1">
              <router-link
                :to="{ name: 'listado-materia-prima-proveedor', params: { 'idBusiness': idBusiness, 'idProveedor': idProveedor, 'NomProveedor': NomProveedor, 'pag': pag, 'desdeProveedor': 1 } }">
                {{ $t("listadoMateriaPrimaProveedor") }}
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} {{ $t("subproducto") }}
            </li>

          </ol>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h2 class="tituloNumier">
                <i class="fa fa-building"></i>
                {{ nombreNegocio }}
              </h2>
              <hr />
            </div>
            <!--CATEGORIAS-->
            <div class="col-md-4">
              <div class="form-group">
                <router-link :to="{
                  name: 'categoria',
                  params: {
                    idBusiness: idBusiness,
                    desdeProveedor: 2,
                    idSubproducto: idSubproducto,
                  },
                }">
                  <span style=" font-size: small;color: #0976b4; float: right">{{ $t("nuevaEtiqueta") }}</span>
                </router-link>
                <label><strong>{{ $t("etiqueta") }}</strong></label>

                <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                  :placeholder="$t('seleccioneEtiqueta')">
                  <el-option v-for="category in listCategory" class="select-primary" :value="category.id"
                    :label="category.name" :key="category.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!--PROVEEDORES-->
            <div class="col-md-4">
              <div class="form-group">
                <router-link :to="{
                  name: 'proveedor',
                  params: {
                    idBusiness: idBusiness,
                    idSubproducto: idSubproducto,
                    desdeSubproducto: 1,
                  },
                }">
                  <span style=" font-size: small;color: #0976b4; float: right">{{ $t("nuevoProveedor") }}</span>
                </router-link>
                <label><strong>{{ $t("proveedor") }}</strong></label>

                <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                  :placeholder="$t('seleccionaProveedor')">
                  <el-option v-for="proveedor in listProveedores" class="select-primary" :value="proveedor.id"
                    :label="proveedor.name" :key="proveedor.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!--CASAS-->
            <div class="col-md-4">
              <div class="form-group">
                <router-link :to="{
                  name: 'casa',
                  params: {
                    idBusiness: idBusiness,
                    idSubproducto: idSubproducto,
                    desdeSubproducto: 1,
                  },
                }">
                  <span style=" font-size: small;color: #0976b4; float: right">{{ $t("nuevaCasa") }}</span>
                </router-link>
                <label><strong>{{ $t("casa") }}</strong></label>

                <el-select class="select-default" size="large" v-model="subproducto.idCasa" filterable
                  :placeholder="$t('seleccionaCasa')">
                  <el-option v-for="casa in listCasas" class="select-primary" :value="casa.id" :label="casa.name"
                    :key="casa.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-8">
              <div class="form-group">
                <label for="nameCasa"><strong>{{ $t("nombreSubproducto") }}
                    <span style="color: red">*</span></strong></label>
                <input type="text" class="form-control" :class="{
                  'is-valid':
                    subproducto.name.length > 0 &&
                    subproducto.name.length <= maxNameSubproducto,
                  'is-invalid': subproducto.name.length > maxNameSubproducto,
                }" id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name" ref="name" />
                <input type="hidden" v-model="subproducto.xname" />
                <small class="form-text text-muted">{{ subproducto.name.length }}/50</small>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="codigodebarrasubproducto">
                  <strong>{{ $t("codigoBarra") }}</strong>
                </label>
                <input type="text" class="form-control" id="codigodebarrasubproducto"
                  v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="direccionsubproducto"><strong>{{ $t("descripcion") }}</strong></label>
                        <input type="text" class="form-control" id="direccionsubproducto"
                          v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("tipo") }}</strong></label>

                        <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                          :placeholder="$t('seleccionaTipo')">
                          <el-option v-for="tipo in listaTipo" class="select-primary" :value="tipo" :label="tipo"
                            :key="tipo">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="escandalloSubproducto"><strong>{{ $t("escandallo") }}</strong></label>
                        <!--<input
                          type="number"
                          min="0"
                          class="form-control"
                          id="escandalloSubproducto"
                          v-bind:placeholder="$t('introduzcaEscandallo')"
                          v-model="subproducto.escandallo"
                        />-->
                        <el-input-number id="escandalloSubproducto" v-model="subproducto.escandallo" :min="0"
                          :precision="0" :controls="false" :placeholder="$t('introduzcaEscandallo')">
                        </el-input-number>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label><strong>{{ $t("colorBoton") }}</strong></label>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="amarillo" />
                              <div class="colorWrap" style="background-color: #ffec9f"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="rojo" />
                              <div class="colorWrap" style="background-color: #ffbbbb"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="verde" />
                              <div class="colorWrap" style="background-color: #c1ffc1"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="morado" />
                              <div class="colorWrap" style="background-color: #ffbfff"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="blanco" />
                              <div class="colorWrap" style="background-color: #FFFFFF"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="azul" />
                              <div class="colorWrap" style="background-color: #cad3ff"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="naranja" />
                              <div class="colorWrap" style="background-color: #ffa54a"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="gris" />
                              <div class="colorWrap" style="background-color: #bbbbbb"></div>
                            </label>
                          </div>
                        </div>

                        <div class=" col-md-2 col-4">
                          <div class="radio">
                            <label>
                              <input v-model="subproducto.color" type="radio" name="colors" value="negro" />
                              <div class="colorWrap" style="background-color: #000000"></div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="orden"><strong>{{ $t("orden") }}</strong></label>
                        <input type="text" class="form-control" id="orden" v-bind:placeholder="$t('orden')"
                          v-model="subproducto.orden" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="precioCompraSubproductoSinIva"><strong>{{
                          $t("precioCompraSinIva")
                        }}</strong></label>
                        <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                        <!--type="number"-->
                        <!--id="precioCompraSubproductoSinIva"-->
                        <!--@change="calculatePrice(subproducto,false)"/>-->

                        <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                          currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, false)"
                          v-model="subproducto.precioCompraSinIva"
                          @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label><strong>{{ $t("tipoIva") }}</strong></label>

                        <el-select v-if="action === $i18n.t('nueva')" class="select-default" size="large"
                          v-model="subproducto.tipoIva" filterable @change="calculatePrice(subproducto, false)"
                          :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="tax in taxList" class="select-primary" :value="tax" :label="tax" :key="tax">
                          </el-option>
                        </el-select>

                        <el-select v-else class="select-default" size="large" v-model="subproducto.tipoIva" filterable
                          @change="calculatePrice(subproducto, false)" :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="iva in taxList" class="select-primary" :value="iva" :label="iva" :key="iva">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="cuotaIVA"><strong>{{ $t("cuotaIVA") }}</strong></label>
                        <input class="form-control" :value="(
                          (subproducto.precioCompraSinIva -
                            (subproducto.precioCompraSinIva *
                              subproducto.descuentoCompra) /
                            100) *
                          (subproducto.tipoIva / 100)
                        ).toFixed(2)
                          " type="number" disabled id="cuotaIVA" />
                      </div>
                    </div>

                    <!--sub.precio_compra/(1+sub.iva/100)) - parseFloat(sub.precio_compra/(1+sub.iva/100))*parseFloat((sub.dto_compra/100))) * (1+sub.iva/100) -->

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="precioCompraDto"><strong>{{
                          $t("precioCompraConDescuento")
                        }}</strong></label>

                        <vue-numeric currency="€" class="form-control" inputmode="decimal" type="text"
                          currency-symbol-position="suffix" :precision="4" disabled
                          @blur="calculatePrice(subproducto, true)" @keydown.native="$methods.evitarComasDecimales"
                          :value="(subproducto.precioCompraSinIva - (subproducto.precioCompraSinIva * subproducto.descuentoCompra) / 100)
                            "></vue-numeric>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="precioCompraSubproducto"><strong>{{
                          $t("precioCompraConIva")
                        }}</strong></label>
                        <!--<input class="form-control" v-model="subproducto.precioCompra"-->
                        <!--type="number"-->
                        <!--id="precioCompraSubproducto"-->
                        <!--@keyup="calculatePrice(subproducto,true)"/>-->
                        <vue-numeric currency="€" class="form-control" inputmode="decimal" type="text"
                          currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                          v-model="subproducto.precioCompra"
                          @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="descuentoCompraSubproducto"><strong>{{ $t("descuentoCompra")
                            }}</strong></label><span style="font-size: x-small">
                          {{ $t("porcentaje") }}</span>
                        <input type="number" min="0" class="form-control" id="descuentoCompraSubproducto"
                          placeholder="0%" v-model="subproducto.descuentoCompra" />
                      </div>
                    </div>
                    <!-- PRUEBA -->
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="porcentajeCompraSubproducto"><strong>{{ $t("avisoPorcentajeCompra")
                            }}</strong></label><span style="font-size: x-small">
                          {{ $t("porcentaje") }}</span>
                        <input type="number" min="0" class="form-control" id="porcentajeCompraSubproducto"
                          placeholder="0%" v-model="subproducto.avisoPorcentajeCompra" />
                      </div>
                    </div>
                    <div class="col-md-12" style="padding-top: 15px">
                      <div v-if="idBusiness==5831" class="form-group">
                        <div class="form-group">
                          <label>
                            <strong>{{ $t("fijarprecio") }}</strong>
                          </label>
                          <el-switch v-model="subproducto.fixed_price_state" active-color="#13ce66" inactive-color="#bcbcbc">
                          </el-switch>
                          <span style="font-size: x-small">
                            {{ $t("preciofijado") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div :class="$cookies.isKey('sectores') ? 'col-md-3' : 'col-md-2'"
              :style="$cookies.isKey('sectores') ? 'padding-top: 20px' : 'padding-top: 35px'">
              <div class="form-group">
                <div class="form-group">
                  <label>
                    <strong>{{ $t("guardarEnAlmacen") }}</strong>
                  </label>
                  <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66" inactive-color="#bcbcbc">
                  </el-switch>
                  <label style="padding-top: 5px" v-if="$cookies.isKey('sectores')">
                    <strong>{{ $t("noMostrarInformeSectores") }}</strong>
                  </label>
                  <el-switch v-if="$cookies.isKey('sectores')" v-model="subproducto.noMostrarInformeSectores"
                    active-color="#13ce66" inactive-color="#bcbcbc">
                  </el-switch>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="stockMinimoSubproducto"><strong>{{ $t("unidadesStockMinimo") }}</strong></label>
                <input type="number" min="0" class="form-control" id="stockMinimoSubproducto"
                  v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="stockMinimoSubproductoPartes"><strong>{{ $t("partesStockMinimo") }}</strong></label>
                <input type="number" min="0" :max="parseInt(subproducto.escandallo) - 1" class="form-control"
                  id="stockMinimoSubproductoPartes" v-bind:placeholder="$t('introduzcaLasPartesDelStockMinimo')"
                  v-model="subproducto.stockMinimoPartes" />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="stockOptimoSubproducto"><strong>{{ $t("stockOptimo") }}</strong></label>
                <input type="number" min="0" class="form-control" id="stockOptimoSubproducto"
                  v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
              </div>
            </div>
            <!--                        <div class="col-md-2">-->
            <!--                            <div class="form-group">-->
            <!--                                <label for="stockOptimoSubproductoPartes"><strong>Partes stock óptimo</strong></label>-->
            <!--                                <input type="number" min="0" :max="subproducto.escandallo" class="form-control"-->
            <!--                                       id="stockOptimoSubproductoPartes" v-bind:placeholder="'Introduzca las partes del stock óptimo'"-->
            <!--                                       v-model="subproducto.scok">-->
            <!--                            </div>-->
            <!--                        </div>-->

            <div class="col-md-2" style="padding-top: 35px">
              <div class="form-group">
                <div class="form-group">
                  <label>
                    <strong>{{ $t("baja") }}</strong>
                  </label>
                  <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                  </el-switch>
                </div>
              </div>
            </div>
            <div v-if="listCuentasSage.length > 1" class="col-md-12">
              <hr />
              <label><strong>{{ tieneDimoni ? $t('enlaceContable') : $t('sage200') }}</strong></label>
              <br />
              <label>{{ $t('aContinuacionSeListaranLasCuentasDeTipo') }}
                <strong>{{ $t('gastoMinuscula') }}</strong> {{ $t('paraQue') }} <strong>{{ $t('asocieMinuscula')
                  }}</strong>
                {{ $t('unaParaSuPosterior') }} <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') :
                  $t('relacionEnSage') }}</strong></label>
              <br />
              <el-select class="select-default select-account" v-model="subproducto.idCuenta" filterable
                :placeholder="$t('seleccioneUnaCuenta')">
                <el-option v-for="cuenta in listCuentasSage" class="select-primary" :value="cuenta.id" :label="cuenta.codigoCuenta +
                  cuenta.codigoSubCuenta +
                  ' - ' +
                  cuenta.nombreCuenta
                  " :key="cuenta.id">
                </el-option>
              </el-select>
              <br />
            </div>
            <div class="col-md-12" v-if="configuradorPLU || tieneTspoonlab || tieneA3Software">
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP</strong><strong
                      v-else>PLU</strong></label>
                </div>
                <div class="col-md-2 col-12">
                  <el-input v-model="subproducto.PLU"></el-input>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <hr />
              <button class="btn btn-primary"
                @click="sectores && $cookies.isKey('sectores') ? comprobarCodigoBarras() : saveSubproducto()"
                :disabled="inProgress">
                <i class="fa fa-check-square"></i> {{ $t("guardar") }}
              </button>
              <router-link :to="{
                name: 'subproductos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness, pag: pag },
              }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
                </button>
              </router-link>
              <el-checkbox v-model="checkReply" v-if="!sectores && !$cookies.isKey('sectores')" border
                class="checkbox-element">
                {{ $t("replicar") }}
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="modalReply" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProveedor") }}</h4>
        </div>
        <div class="modal-footer mb-2" v-if="this.sectores && this.$cookies.isKey('sectores')">
          <button class="btn btn-primary" @click="replySubproductos">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
        <div class="modal-body" v-if="!this.sectores && !this.$cookies.isKey('sectores')">
          <input type="checkbox" id="checkMinimoyOptimo" name="checkMinimoyOptimo" v-model="checkMinyOptm" />
          <label for="checkMinimoyOptimo" class="checkMinimoyOptimo">{{
            $t("actualizarStockMinimoYOptimo")
          }}</label>

          <hr />

          <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
            @click="selectAll" />
          <label for="checkSelectAll" class="checkSelectAll">{{
            $t("seleccionarTodos")
          }}</label>

          <div v-for="business in listBusinesses">
            <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border class="checkbox-element"
              style="width: 100%">
              {{ business.establishmentName }}
            </el-checkbox>
          </div>
        </div>
        <div class="modal-footer" v-if="!this.sectores && !this.$cookies.isKey('sectores')">
          <button class="btn btn-default" @click="closeModal()">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="replySubproductos">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Switch,
} from "element-ui";

export default {
  props: [
    "idBusiness",
    "idSubproducto",
    "idProveedor",
    "NomProveedor",
    "pag",
    "ultimaCategoria",
    "ultimoProveedor",
    "ultimaCasa",
    "filtro",
    "SpProv",
  ],
  created() {

    if (this.sectores && this.$cookies.isKey("sectores")) {
      this.checkReply = true;
    }

    this.action = this.idSubproducto
      ? this.$i18n.t("editar")
      : this.$i18n.t("nueva");

    this.loadingGeneral = Loading.service({ text: "Cargando..." });

    this.getTaxRates();
    //this.getConfigDimoni();

    this.getIdTpvByBusiness();
    this.identificacionNegocio();
    this.getCategory();
    this.getProveedores();
    this.getCasas();
    this.getConfigTspoonlab();
    this.getConfigConfiguradorPLU();
    this.getConfigA3Software();
    this.checkBusinessSector();

    if (this.idSubproducto) {
      this.getSubproducto();
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  mounted() {
    this.$refs.name.focus();
  },
  computed: {
    ...mapState(["sectores", "listaSectores"]),
  },

  updated() {
    this.nPeticiones++;

    if (this.idSubproducto) {
      if (this.nPeticiones === 6) {
        this.loadingGeneral.close();
      }
    } else {
      if (this.nPeticiones === 5) {
        this.loadingGeneral.close();
      }
    }
  },

  data() {
    return {
      loadingGeneral: null,
      nPeticiones: 0,

      subproducto: {
        idTag: 0,
        idSupplier: 0,
        idCasa: 0,
        name: "",
        xname: "",
        descripcion: "",
        codigoBarras: "",
        tipo: this.$t("uds"),
        tipoIva: "21.00",
        descuentoCompra: 0,
        precioCompra: 0,
        precioCompraSinIva: 0,
        escandallo: 1,
        stockMinimo: 0.0,
        stockOptimo: 0.0,
        //stockOptimoPartes: 0.000,
        stockMinimoPartes: 0.0,
        color: "amarillo",
        guardarAlmacen: true,
        baja: false,
        orden: 999,
        idCuenta: "0",
        PLU: "",
        avisoPorcentajeCompra: 0,
        noMostrarInformeSectores: 0,
        fixed_price_state: false
      },

      listaTipoIva: [0, 4, 10, 21],
      listaTipo: [
        this.$t("uds"),
        this.$t("cajas"),
        this.$t("botellas"),
        this.$t("barriles"),
        this.$t("palets"),
        this.$t("bolsas"),
        "Kgs",
        this.$t("litros"),
        this.$t("rollos"),
      ],

      listCasas: [],
      listProveedores: [],
      checkSelectAll: false,
      listBusinesses: [],
      listCategory: [],
      checkReply: false,
      maxNameSubproducto: 50,
      action: "",
      inProgress: false,
      nombreNegocio: "",

      taxList: [],
      checkMinyOptm: false,

      defaultTaxRate: "",
      idTpv: "",
      listCuentasSage: [],

      tieneDimoni: false,
      tieneTspoonlab: false,
      tieneA3Software: false,
      configuradorPLU: false,
      isSector: false,
    };
  },
  methods: {
    getConfigDimoni() {
      var config = {
        params: {
          idTpv: this.idTpv,
          idBusiness: this.idBusiness,
          numConfig: 83,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.result) {
            vm.tieneDimoni = true;
          } else {
            vm.tieneDimoni = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigTspoonlab() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 112,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneTspoonlab = true;
          } else {
            vm.tieneTspoonlab = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigConfiguradorPLU() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 117,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.configuradorPLU = true;
          } else {
            vm.configuradorPLU = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigA3Software() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 113,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneA3Software = true;
          } else {
            vm.tieneA3Software = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cargarCuentasPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/getSageBusinessDataByIdTpv",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCuentasSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });

            response.data.result.forEach((cuenta) => {
              if (cuenta.tipo == "G") {
                vm.listCuentasSage.push(cuenta);
              }
            });
            //vm.listCuentasSage = response.data.result;

            vm.respuesta = true;
          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTaxRates() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "taxes/getOnlyTaxes", config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.taxList = response.data.result;
              vm.defaultTaxRate = response.data.result[0];
            } else {
              vm.taxList = false;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    calculatePrice(subproducto, iva) {
      if (iva) {
        // console.log("IF 1: precioCompra " + subproducto.precioCompra);

        let newPrice = subproducto.precioCompra / (1 + subproducto.tipoIva / 100);
        subproducto.precioCompraSinIva = parseFloat(newPrice.toFixed(3));

        // console.log("IF 1: precioCompraSinIva final " + subproducto.precioCompraSinIva);
      }
      else {
        // console.log("IF 2: precioCompra " +subproducto.precioCompra);
        // console.log("IF 2: precioCompra " +subproducto.precioCompraSinIva);

        subproducto.precioCompra =
          parseFloat(subproducto.precioCompraSinIva) * (1 + subproducto.tipoIva / 100);
        subproducto.precioCompra = parseFloat(subproducto.precioCompra.toFixed(3));

        // console.log("IF 2: precioCompra final " + subproducto.precioCompra);
      }
    },

    checkCampos() {
      if (this.subproducto.name.length > this.subproducto) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameSubproducto +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.subproducto.name === null ||
        this.subproducto.name.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },
    getSubproducto() {
      var config = {
        params: {
          idSubproduct: this.idSubproducto,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getSubproductById",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.subproducto = response.data.result;
            vm.subproducto.xname = response.data.result.name;

            vm.calculatePrice(vm.subproducto, true);
            if (vm.ultimaCategoria) {
              vm.subproducto.idTag = vm.ultimaCategoria;
            }

            if (vm.ultimoProveedor) {
              vm.subproducto.idSupplier = vm.ultimoProveedor;
            }

            if (vm.ultimaCasa) {
              vm.subproducto.idCasa = vm.ultimaCasa;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getCategory() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinEtiqueta"),
                id: 0,
              };

              vm.listCategory.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinEtiqueta"),
                  id: 0,
                };

                vm.listCategory.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCategory.push(categoryname);
            }

            if (vm.ultimaCategoria) {
              vm.subproducto.idTag = vm.ultimaCategoria;
            }
          } else {
            swal({
              title: vm.$t("sinEtiqueta"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getProveedores() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getSuppliersByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinProveedores"),
                id: 0,
              };

              vm.listProveedores.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let proveedor = {
                  name: vm.$t("sinProveedores"),
                  id: 0,
                };

                vm.listProveedores.push(proveedor);
              }

              let proveedorname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listProveedores.push(proveedorname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getCasas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getCasasByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let casas = {
                name: vm.$t("sinCasas"),
                id: 0,
              };

              vm.listCasas.push(casas);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let casas = {
                  name: vm.$t("sinCasas"),
                  id: 0,
                };

                vm.listCasas.push(casas);
              }

              let casasname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCasas.push(casasname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    comprobarCodigoBarras() {
      if ((this.sectores && this.$cookies.isKey('sectores')) && (this.subproducto.codigoBarras == "" || this.subproducto.codigoBarras == " ")) {
        swal({
          title: this.$t("atencion"),
          text: "Está a punto de guardar un subproducto sin código de barras. ¿Está seguro? Esto sobreescribirá los códigos de barra de los productos equivalentes en los sectores relacionados.",
          showCancelButton: true,
          confirmButtonText: 'Sí, estoy seguro',
          confirmButtonColor: '#3085d6',
          cancelButtonText: `Cancelar`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.value) {
            this.saveSubproducto();
          }
        })
      } else {
        this.saveSubproducto();
      }
    },
    saveSubproducto() {
      if (this.checkCampos()) {
        this.inProgress = true;

        if (this.sectores && this.$cookies.isKey("sectores")) {
          this.checkReply = true;
          this.listBusinesses.forEach(function (business) {
            business.checked = true;
          });
          if (!this.isSector) {
            this.checkReply = false;
          }
        }

        this.subproducto.fixed_price_state = this.subproducto.fixed_price_state ? 1 : 0;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idBusiness: this.idBusiness,
          subproduct: this.subproducto,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = this.idSubproducto
          ? "editSubproductById"
          : "newSubproductByBusiness";
        this.axios
          .post(
            this.$store.getters.apiUrl + "subproducts/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.idSubproducto
                ? vm.$t("actualizado")
                : vm.$t("creado");
              vm.$notify({
                message:
                  vm.$t("subproductoDeVerdad") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              if (vm.checkReply) {
                if (!vm.idSubproducto) {
                  vm.subproducto.xname = vm.subproducto.name;
                }

                vm.axios
                  .get(
                    vm.$store.getters.apiUrl +
                    "general/getBusinessesByUserReplicado",
                    config
                  )
                  .then(function (response) {
                    if (response.data.response) {
                      vm.listBusinesses = response.data.result;

                      if (vm.sectores && vm.$cookies.isKey("sectores")) {
                        if (vm.isSector) {
                          vm.replySubproductosSectores();
                        }
                      } else {
                        vm.$modal.show("modalReply");
                      }

                    } else {
                      swal({
                        title: vm.$t("atencion"),
                        text: response.data.message,
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                      });
                    }
                  });
              } else {
                vm.$router.push({
                  name: "subproductos",
                  query: { filtro: vm.filtro },
                  params: { idBusiness: vm.idBusiness, pag: vm.pag },
                });
              }
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    replySubproductosSectores() {

      if (this.sectores && this.$cookies.isKey("sectores")) {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let xbusinesses = new Array();
      this.listBusinesses.forEach(function (business) {
        if (business.checked && business.id !== vm.idBusiness) {
          xbusinesses.push(business);
        }
      });

      var params = {
        idBusiness: this.idBusiness,
        listBusinesses: xbusinesses,
        subproduct: this.subproducto,
        checkMin: this.checkMinyOptm,
        jwt: this.$store.getters.jwt,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "subproducts/replySubproductSectores",
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {
            vm.closeModal();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    replySubproductos() {

      if (this.sectores && this.$cookies.isKey("sectores")) {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let xbusinesses = new Array();
      this.listBusinesses.forEach(function (business) {
        if (business.checked && business.id !== vm.idBusiness) {
          xbusinesses.push(business);
        }
      });

      var params = {
        idBusiness: this.idBusiness,
        listBusinesses: xbusinesses,
        subproduct: this.subproducto,
        checkMin: this.checkMinyOptm,
        jwt: this.$store.getters.jwt,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "subproducts/replySubproduct",
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {
            vm.closeModal();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    getIdTpvByBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
        .then(function (response) {
          vm.idTpv = response.data;
          vm.cargarCuentasPorIdTpv();
          vm.getConfigDimoni();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkBusinessSector() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkBusinessSector", config)
        .then(function (response) {
          vm.isSector = response.data.result;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeModal() {
      this.$modal.hide("modalReply");
      this.$router.push({
        name: "subproductos",
        query: { filtro: this.filtro },
        params: { idBusiness: this.idBusiness, pag: this.pag },
      });
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function (business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }
    },
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}

.colorWrap {
  width: 50px;
  height: 50px;
  border: 1px solid #888;
  border-radius: 3px;
  float: right;
  margin-left: 10px;
  cursor: pointer;
}

.select-account {
  display: block;
  padding-right: 2px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Subproductos/SubproductoForm.vue